import styled from 'styled-components';

export const PaymentOption = styled.button<{ active?: boolean; color: string }>`
  flex: 1;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border: 2px solid ${(props) =>
    props.active ? (props.color ?? '#00D95F') : '#D9DDE3'};
  border-radius: 12px;
  background: ${(props) =>
    props.active ? (props.color ?? '#00D95F') : '#fff'};
  color: ${(props) => (props.active ? '#fff' : '#18233A')};
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 12px 8px;

  &:hover {
    border-color: ${(props) => props.color ?? '#00D95F'};
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }

  span {
    font-size: 13px;
    font-weight: 600;
    text-align: center;
    letter-spacing: -0.1px;
  }

  @media (max-width: 640px) {
    min-height: 70px;
    gap: 8px;
    padding: 10px 6px;

    span {
      font-size: 11px;
    }
  }
`;
